import React, { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

// Hoisted so the objects keep a stable reference between renders.
const EASE = [0.2, 0.8, 0.2, 1];
const VIEWPORT = { once: true, amount: 0.2 };
const IN_VIEW = { opacity: 1, y: 0 };
const DURATION = 0.45;

export const Reveal = ({ children, delay = 0, className = "", y = 16 }) => {
  const reduce = useReducedMotion();

  const initial = useMemo(() => ({ opacity: 0, y }), [y]);
  const transition = useMemo(() => ({ duration: DURATION, delay, ease: EASE }), [delay]);

  if (reduce) return <div className={className}>{children}</div>;

  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={IN_VIEW}
      viewport={VIEWPORT}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};

/** Width/alignment wrapper for a section heading block. */
const headingLayout = (align, wide) => {
  if (align === "center") {
    return `mx-auto ${wide ? "max-w-4xl" : "max-w-2xl"} text-center`;
  }
  return wide ? "max-w-none" : "max-w-2xl";
};

export const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "dark",
  testId,
  wide = false,
}) => {
  const light = tone === "light";
  return (
    <div data-testid={testId} className={headingLayout(align, wide)}>
      {eyebrow ? (
        <p className={light ? "eyebrow text-[#7fd6d9]" : "eyebrow"}>{eyebrow}</p>
      ) : null}
      <h2
        className={`font-display ${
          eyebrow ? "mt-3" : ""
        } text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight ${
          light ? "text-white" : "text-[#0b1d3a]"
        }`}
      >
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-4 text-sm sm:text-base leading-relaxed ${
            light ? "text-slate-200" : "text-slate-600"
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
};
